import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import quickLaunchActions from 'redux/actions/quickLaunchActions'
import generalActions from 'redux/actions/generalActions'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.QUICK_LAUNCH_LAUNCH_LESSON_FAILED

class quickLaunchFailedConfirm extends PureComponent {

	close = () => {
		this.props.actions.close(CONFIRM_TYPE)
	}

	render() {
		return (
			<Confirm
				btOne={localize('global_cancel')}
				btTwo={localize('global_retry')}
				alertMessage={localize('quicklaunch_launch_error_confirm')}
				actionButtonType={0}
				actionOne={this.props.actions.cancel}
				actionTwo={this.props.actions.retry}
				closeButton={false}
			/>
		)
	}
}

quickLaunchFailedConfirm.propTypes = {
	actions: PropTypes.shape({
		retry: PropTypes.func.isRequired,
		cancel: PropTypes.func.isRequired,
		close: PropTypes.func.isRequired,
	}).isRequired,
}


function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		retry: quickLaunchActions.retryLaunch,
		cancel: quickLaunchActions.cancelLaunch,
		close: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(quickLaunchFailedConfirm)

export { quickLaunchFailedConfirm }
